import { combineReducers } from "redux";

import dataReducer from "./data";

const rootReducer = combineReducers({
    dataReducer,
});

export default rootReducer;


